import { HttpErrorResponse } from '@angular/common/http';

import { ScopeValueUsedInRolesErrorItem } from '@app/common-modules/common-scope-value-used-in-roles-dialog/common-scope-value-used-in-roles-dialog.model';

const MAX_NAME_SCAN_DEPTH = 4;

export const isScopeValueUsedInRolesError = (
  err: unknown,
): err is HttpErrorResponse & { error: { data: ScopeValueUsedInRolesErrorItem[] } } =>
  err instanceof HttpErrorResponse &&
  !(err.error instanceof Blob) &&
  err.error?.exception_key === 'scopeValueUsedInRoles' &&
  Array.isArray(err.error.data);

/**
 * Collects uuid -> name pairs from a bulk (array) request body so scope values
 * deleted via bulk payloads can be labeled in the error dialog.
 */
export const collectUuidNameMap = (body: unknown): Record<string, string> =>
  Object.fromEntries(Array.isArray(body) ? body.flatMap(item => collectUuidNameEntries(item, 0)) : []);

const collectUuidNameEntries = (value: unknown, depth: number): [string, string][] => {
  if (depth > MAX_NAME_SCAN_DEPTH || value === null || typeof value !== 'object') {
    return [];
  }

  if (Array.isArray(value)) {
    return value.flatMap(item => collectUuidNameEntries(item, depth + 1));
  }

  const record = value as Record<string, unknown>;
  return [...toUuidNameEntry(record), ...Object.values(record).flatMap(item => collectUuidNameEntries(item, depth + 1))];
};

const toUuidNameEntry = (record: Record<string, unknown>): [string, string][] =>
  typeof record.uuid === 'string' && typeof record.name === 'string' ? [[record.uuid, record.name]] : [];
